import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentTrackingPage() {
  return (
    <LatamAgentPage locale="en-LATAM" agentKey="tracking_and_status_updates" />
  );
}
